<script>
    export let id;
    
    let src = "./assets/2024/kerst/" + id + ".png"
</script>

<img {src} alt="{id}"/>

<style>
    img {
        max-width: 350px;
        height: auto;
    }
</style>